import { LinkIcon } from '@st/theme'
import { AppRoute, routes } from '~/features/routes'
import { useSelect } from '~/store'
import { FullScreenNoticePage } from '~/theme'

type Props = {
  newRoute: AppRoute
}
export function OrganizationRouteChangedPage({ newRoute }: Props) {
  const origin = useSelect('route', (state) => state.location.origin)
  const url = origin + routes.toPath(newRoute)
  return (
    <FullScreenNoticePage title="URL Changed" icon={<LinkIcon className="size-10" />}>
      <p className="max-w-2xl text-center">
        The URL has changed to{' '}
        <a className="link text-blue-500 underline" href={url}>
          {url}
        </a>
        .
      </p>
      <p>Please make sure to bookmark the new URL.</p>
    </FullScreenNoticePage>
  )
}
